import { FC } from 'react';

import { Scrollable, ScrollableProps } from '@catawiki/cata-style';

import styles from './styles.module.scss';

export const FullWidthScrollable: FC<ScrollableProps> = ({
  children,
  ...params
}) => (
  <div className={`${styles.cFullWidthScrollable} u-full-width`}>
    <div className={`${styles.cScrollableWrapper} u-wrapper`}>
      <Scrollable
        containerClassName={styles.cFullWidthScrollableContainer}
        {...params}
      >
        {children}
      </Scrollable>
    </div>
  </div>
);
